import { useTranslation } from 'react-i18next';

import { CommandGroup, CommandSeparator } from '@/components/ui/command';

import { QuickActionsGroup } from './QuickActionsGroup';

type NoResultsGroupProps = {
  search: string;
  onAction: (action: () => void, navigateTo?: { path: string; label: string }) => void;
  onConversationSearch?: () => void;
};

export const NoResultsGroup = ({ search, onAction, onConversationSearch }: NoResultsGroupProps) => {
  const { t } = useTranslation();

  const trimmed = search.trim();

  return (
    <>
      <CommandGroup forceMount>
        <p className="px-2 py-1.5 text-xs font-medium text-muted-foreground">
          {t('command_palette.no_results_for', { 0: trimmed })}
        </p>
      </CommandGroup>
      <CommandSeparator />
      <QuickActionsGroup
        onAction={onAction}
        querySuffix={search}
        forceMount
        onConversationSearch={onConversationSearch}
      />
    </>
  );
};
